// @core/api/endpoints/bootstrap/get_system_info.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetSystemInfoResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Get system information
 * Probes infrastructure and services to report what is available. Includes secret service seal status for the vault initialization step.
 * @public This endpoint does not require authentication
 */
export async function GetSystemInfo(
  params?: {
  },
  options?: RequestOptions
): Promise<GetSystemInfoResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/system-info`;
  const requestOptions = { ...options, skipAuth: true };
  return client.get<GetSystemInfoResponse>(requestPath, { ...requestOptions, params });
}
